import { styled, TextareaAutosize } from '@mui/material'

export const StyledTextarea = styled(TextareaAutosize)`
  flex-grow: 1;
  border: 0;
  outline: 0;
  background: none;
  font: inherit;
  resize: none;
  padding: 8px;
  padding-right: 0;
  max-height: 200px;
  align-content: space-evenly;

  /* width */
  ::-webkit-scrollbar {
    width: 8px;
    border-radius: 8px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f4f5;
    border-radius: 8px;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #ced2db;
    border-radius: 8px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #a9b0bf;
    border-radius: 8px;
  }
`
